/**
 * Строка «Обучение по экологической безопасности» в подразделе «Проектные работы»
 * (ecology-followup). Данные — из журнала обучения (направление «Экология»), заказ оформляется в
 * разделе «Обучение»: так решил заказчик 17.09, поэтому здесь только показ и переход.
 *
 * Эколог 18.09 уточнил, кто должен быть обучен: руководитель — в приоритете, либо иной
 * ответственный; Росприроднадзор рекомендует обучить второго на время отсутствия первого — об этом
 * кабинет подсказывает, когда обучен один человек.
 */
import { GraduationCap } from 'lucide-react'
import type { EcoTraining } from '@/lib/api'
import { formatEcoDate } from '@/lib/ecology'
import { AppLink } from '@/app/navigation'
import { Card } from '@/design-system/components/layout/card'
import { Badge } from '@/design-system/components/primitives/badge'

export function EcoTrainingCard({
  training,
  /** Куда ведёт ссылка на журнал: у клиента — своё обучение, у команды — журнал обучения. */
  journalHref,
}: {
  training: EcoTraining
  journalHref: string
}) {
  const trained = training.people.filter((p) => p.valid)
  return (
    <Card
      className="mb-4"
      header={
        <span className="flex flex-wrap items-center justify-between gap-2">
          <span className="flex items-center gap-2">
            <GraduationCap className="size-4 shrink-0 stroke-current text-txt-secondary" aria-hidden />
            Обучение по экологической безопасности
          </span>
          <Badge variant={training.status.color}>{training.status.label}</Badge>
        </span>
      }
    >
      {trained.length === 0 ? (
        <p className="text-13 text-txt-secondary">
          По журналу обучения никто не обучен по направлению «Экология».
        </p>
      ) : (
        <ul className="flex flex-col gap-1">
          {trained.map((person) => (
            <li key={`${person.name}-${person.dueOn}`} className="text-txt">
              {person.name || 'сотрудник'}
              {person.position ? (
                <span className="text-13 text-txt-secondary"> · {person.position}</span>
              ) : null}
              {person.dueOn ? (
                <span className="text-13 text-txt-secondary"> · до {formatEcoDate(person.dueOn)}</span>
              ) : null}
            </li>
          ))}
        </ul>
      )}
      {training.hint ? <p className="mt-2 text-13 text-amber">{training.hint}</p> : null}
      <p className="mt-2 text-12 text-txt-tertiary">
        Сроки и заказ обучения — в разделе <AppLink to={journalHref}>«Обучение»</AppLink>; здесь
        строка только показывается.
      </p>
    </Card>
  )
}
